import { ComponentsProps } from '@mui/material/styles/props';
import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { Theme } from '@mui/material';
import { ComponentsVariants } from '@mui/material/styles/variants';
import { primaryColor, successColor } from './palette';

export const muiTabs: {
    defaultProps?: ComponentsProps['MuiTabs'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTabs'];
    variants?: ComponentsVariants['MuiTabs'];
} = {
    styleOverrides: {
        root: {
            minHeight: 'initial',
        },
        indicator: {
            backgroundColor: successColor.main,
        },
    },
};

export const muiTab: {
    defaultProps?: ComponentsProps['MuiTab'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTab'];
    variants?: ComponentsVariants['MuiTab'];
} = {
    styleOverrides: {
        root: {
            textTransform: 'none',
            fontSize: 16,
            fontWeight: 600,
            margin: `0px 12px 6px 0px`,
            padding: 0,
            minHeight: 'initial',
            lineHeight: 'initial',
            minWidth: 'auto',
            '&:first-of-type': {
                marginLeft: 0,
            },
            '&:last-of-type': {
                marginRight: 0,
            },
        },
        textColorPrimary: {
            color: primaryColor[50],
        },
    },
};
